module.exports = __webpack_public_path__ + "static/media/H_W.ced44c0f.png";